<template>
  <div id="register-step1" class="register-step">
    <div id="content-main">
      <div class="register-header register-header-margin">
        <div>
          <a @click="backaction">
            <span class="icon"> <i class="mdi mdi-arrow-left"></i> </span>
          </a>
        </div>
        <h2>2/3 IDENTIFICACIÓN PROFESIONAL</h2>
        <div>
          <a @click="closeRegister">
            <span class="icon"> <i class="mdi mdi-exit-to-app"></i> </span>
          </a>
        </div>
      </div>

      <div class="register-content">
        <!-- <p
          v-if="getFieldInfo('numcol') !== undefined"
          v-html="texts.register.step2.text1"
        ></p> -->

        <div class="register-forms-container">
          <b-field v-if="getFieldInfo('tratamiento') !== undefined">
            <b-radio-button type="is-primary" v-model="doctor_title" v-for="(tratamiento, i) in getFieldInfo('tratamiento')
              .field_options" :key="i" :native-value="tratamiento">
              <span>{{ tratamiento }}</span>
            </b-radio-button>
          </b-field>
          <b-field :type="nameType" :message="nameMsg">
            <b-icon class="onlyline-icon" pack="mdi" icon="account" size="is-small">
            </b-icon>
            <b-input type="text" class="onlyline" placeholder="Nombre" expanded v-model="user_name" required
              ref="nameField" :disabled="verificado" @blur="validationNameRegister">
            </b-input>
          </b-field>

          <b-field :type="surnameType" :message="surnameMsg">
            <b-input type="text" class="onlyline apellido" placeholder="Apellido" expanded v-model="user_surname" required
              ref="surnameField" :disabled="verificado" @blur="validationSurnameRegister">
            </b-input>
          </b-field>
          <b-field>
            <b-input type="text" class="onlyline apellido" placeholder="Segundo Apellido" expanded v-model="user_surname2"
              ref="surname2Field" :disabled="verificado">
            </b-input>
          </b-field>

          <b-field
            style="flex-wrap: wrap; margin-bottom:5px; margin-top:20px;">
            <p v-if="currentRole === 'doctor'"
              style="margin-right:1em; margin-left:24px; font-size: 13px; text-align:left; margin-bottom:0px;">
              Introduce los 9 dígitos de tu número de colegiado
            </p>
            <p v-if="getCountry.id !== 'ES' || currentRole !== 'doctor'"
              style="margin-right:1em; margin-left:24px; font-size: 13px; text-align:left; margin-bottom:0px;">
              Introduce tu número de identificación profesional
            </p>
          </b-field>

          <b-field id="colegiado-number" custom-class="is-small has-text-success" :type="colegiadoType"
            :message="colegiadoMsg" is-expanded>
            <b-icon class="onlyline-icon" pack="mdi" icon="barcode" size="is-small">
            </b-icon>

            <b-input v-if="currentRole === 'doctor'" type="text" class="onlyline professional_number"
              placeholder="XX  YY  ZZZZZ" v-mask="'99  99  99999'" v-model="professional_number" @blur="validateNumber"
              @input="validateWhenTyping" required ref="professional_numberField" :disabled="verificado">
            </b-input>

            <b-input v-if="getCountry.id !== 'ES' || currentRole !== 'doctor'" type="text" class="onlyline professional_number" placeholder=""
              v-model="professional_number" required ref="professional_numberField" :disabled="verificado"
              @input="validationProfNumberRegister">
            </b-input>

            <a @click="showInfoModal = true" v-if="currentRole === 'doctor'">
              <b-icon pack="mdi" icon="information-outline" size="is-small">
              </b-icon>
            </a>
          </b-field>

          <b-field class="file is-primary" :class="{ 'has-name': !!doctor_professional_doc }" style="margin:25px 0;"
          v-if="getCountry.id !== 'ES' || currentRole !== 'doctor'" :message="docMsg" :type="docType">
            <b-upload v-model="doctor_professional_doc" class="file-label">
              <span class="file-cta">
                <b-icon class="file-icon" icon="upload"></b-icon>
                <span class="file-label">Seleccionar archivo</span>
              </span>
              <span class="file-name" v-if="doctor_professional_doc">
                {{ doctor_professional_doc.name }}
              </span>
            </b-upload>
          </b-field>

          <div class="field" v-if="getCountry.id !== 'ES' || currentRole !== 'doctor'">
            <p style="font-size: 13px;">Adjunte documento acreditativo de su número de identificación profesional.
              Por favor tenga en cuenta la necesidad de la adecuada aportación de este documento. Su registro puede quedar
              condicionado a la correcta verificación del mismo, para lo cual Tok medicine podría ponerse en contacto por
              los
              medios que nos facilite en el proceso de registro.</p>
            <p style="font-size: 13px;">Los archivos deben ser menores que 512 MB.</p>
            <p style="font-size: 13px;">Tipos de archivo permitidos: pdf, jpg, png.</p>
          </div>

          <div class="field" style="margin-top: 30px;" v-if="getFieldInfo('residente') !== undefined">
            <b-checkbox v-model="doctor_resident">Soy médico residente</b-checkbox>
          </div>
          <div class="anios-container" v-if="doctor_resident">
            <b-field label="Año de residencia" horizontal>
              <b-input type="number" min="0" max="9" value="1" style="width:3em;"
                v-model="doctor_resident_year"></b-input>
            </b-field>
          </div>
        </div>
      </div>
      <div class="register-button-container">
        <div v-if="verificado" class="usuario-verificado">
          <!-- USUARIO VERIFICADO-->
        </div>
        <!-- <div v-if="showNoverificado" class="usuario-no-verificado">
              USUARIO NO VERIFICADO
            </div> -->
        <a class="button is-medium is-fullwidth is-primary" :class="{ 'is-loading': isWaitingValidation }"
          :disabled="isWaitingValidation" @click="nextStep">
          Continuar <span v-if="showNoverificado"> (sin verificar) </span>
        </a>
      </div>
      <b-modal :active.sync="showInfoModal" has-modal-card>
        <InfoModal title="¿Cuál es mi número?"
          content="El acceso a esta aplicación utiliza el sistema de validación profesional online de Navandú, en colaboración con el Consejo General de Colegios Oficiales de Médicos (www.cgcom.es).<br>
                Para una correcta validación tiene que indicar su número de colegiado completo con los 9 dígitos, al igual que su nombre y apellidos, tal y como figuran en el registro de médicos colegiados del CGCOM.<br>Para ayudarle, le indicamos que el formato es XXYYZZZZZ, correspondiéndose XX con el código del Colegio Oficial de Médicos en el que se encuentra registrado actualmente, YY con el del Colegio Oficial de Médicos en el que se colegió por primera vez, y ZZZZZ con su número de colegiado con 5 dígitos.<br>Si no tiene número de colegiado, indique un código profesional que le identifique (CNP del SAS, Ordem dos Medicos de Portugal, etc.), y nos pondremos en contacto con Vd. una vez realizada la validación de sus datos por otros medios.<br>Si tiene algún problema con el registro puede ponerse en contacto con el Centro de Atención al Cliente de Navandú, a través del enlace que encontrará en la misma aplicación.">
        </InfoModal>
      </b-modal>
      <b-modal :active.sync="showErrorModal" has-modal-card>
        <InfoModal title="Fallo en la validación "
          content="¡Lo sentimos! Tus datos no han podido ser verificados.<br/> 
              Seguramente sean correctos pero puede haber alguna ligera diferencia con tus datos registrales. Revísalos por favor y si crees que son correctos <strong> continúa con el proceso de registro </strong> <br/> <strong> Podrás seguir usando este servicio si has introducido código premium </strong> <br/> En cualquier caso, termina el registro, realizaremos nosotros unas comprobaciones y nos pondremos en contacto contigo a la mayor brevedad posible">
        </InfoModal>
      </b-modal>
    </div>
    <div id="belowbutton">
      <p class="interface-small-text has-text-grey-light"></p>
    </div>
  </div>
</template>
<script>
import AwesomeMask from 'awesome-mask'
import InfoModal from '../UI/InfoModal'
//import roles from '@/store/types'
import { RegisterStepMixin } from '../mixins/RegisterStepMixin'
import { ToolsMixin } from '../mixins/ToolsMixin'
export default {
  name: 'RegisterStep2b',
  components: {
    InfoModal
  },
  mixins: [RegisterStepMixin, ToolsMixin],
  data: () => ({
    doctor_title: 'Dra',
    doctor_resident: false,
    doctor_resident_year: '0',
    professional_number: '',
    user_name: '',
    user_surname: '',
    user_surname2: '',
    nameMsg: '',
    surnameMsg: '',
    nameType: '',
    surnameType: '',
    verificado: false,
    showNoverificado: false,
    colegiadoType: '',
    colegiadoMsg: '',
    showInfoModal: false,
    showErrorModal: false,
    isWaitingValidation: false,
    nextStepWaitingValidation: false,
    doctor_professional_doc: null,
    doctor_professional_doc_base64: null,
    docType: '',
    docMsg: '',
    file_ext: ''
  }),
  computed: {
    requireValidation() {
      if (this.currentRole === 'medico') return true
      else return false
    },

    getColegiadoClasses() {
      return this.colegiadoClasses
    },
    getRegisterConfiguration() {
      return this.$store.state.register.registerConfiguration
    },
    getCurrentConfiguration() {
      if (this.currentRole === '') return null
      else {
        return this.getRegisterConfiguration.data.filter(
          d => d.rol === this.currentRole
        )[0]
      }
    },
    getCountry() {
      return this.$store.state.register.country
    },
  },
  directives: {
    mask: AwesomeMask
  },
  watch: {
    // whenever question changes, this function will run
    isWaitingValidation: function (newValue) {
      if (newValue == false && this.nextStepWaitingValidation) {
        console.log('isWaitingValidation run')
        this.isWaitingValidation = false
        this.nextStep()
      }
    },

    // When user upload a file, this will transform in base64
    doctor_professional_doc: function (file) {
      console.log('Nuevo fichero')
      this.file_ext = file.name.split('.').pop()

      if (['jpg', 'jpeg', 'png', 'pdf'].includes(this.file_ext)) {
        console.log('Extensión permitida')
        this.docType = ''
        this.docMsg = ''

        if (file) {
          this.createBase64(file)
        } else {
          this.doctor_professional_doc_base64 = null
        }
      } else {
        console.log('Extensión no permitida')
        this.docType = 'is-danger'
        this.docMsg = 'Extensión no permitida'
        return false
      }
    }
  },
  created() { },
  methods: {
    createBase64(file) {
      var reader = new FileReader();

      var self = this;
      reader.onload = (event) => {
        self.doctor_professional_doc_base64 = event.target.result;
        // console.log(self.doctor_professional_doc_base64);
      }

      reader.readAsDataURL(file);
    },
    deleteDropFile(index) {
      this.dropFiles.splice(index, 1)
    },
    backaction() {
      if (this.getCountry.id !== 'ES') {
        this.prevStep()
      } else {
        this.currentRole = ''
      }
    },
    generateProfessional_number() {
      if (this.professional_number !== '') {
        return this.professional_number.replace(/ /g, '')
      } else {
        //Si no se introduce pfnumber devolvemos un cero para que la api no casque
        return '0'
      }
    },
    validateWhenTyping() {
      if (this.getCountry.id !== 'ES') {
        return
      }
      console.log(this.generateProfessional_number().length)
      if (this.generateProfessional_number().length === 9) {
        console.log('validateWhenTyping')
        //var throttled = this._.throttle(this.validateNumber, 1000);
        this.validateNumber()
      }
   },
    validateNumber() {
      console.log('validate number')
      if (this.getCountry.id !== 'ES') {
        return
      }
      this.isWaitingValidation = true
      this.$store
        .dispatch('register/validateDoctorData', {
          user_name: this.user_name,
          user_surname: this.user_surname,
          professional_number: this.generateProfessional_number()
        })
        .then(response => {
          console.log(response)
          if (response.data[0] == true) {
            this.colegiadoType = 'is-primary'
            this.colegiadoMsg = 'Usuario verificado'
            this.verificado = true
            this.showErrorModal = false
            this.showNoverificado = false
          } else if (this.professional_number != '') {
            this.colegiadoType = 'is-danger'
            this.colegiadoMsg = 'Este número de colegiado no parece correcto o no se corresponde con el nombre'
          } else if (this.professional_number === '') {
            this.colegiadoType = ''
            this.colegiadoMsg = ''
          }
        })
        .catch(error => {
          console.log(error)
        })
        .finally(() => {
          this.isWaitingValidation = false
        })
    },
    isFormValid() {
      this.$refs.nameField.checkHtml5Validity()
      this.$refs.surnameField.checkHtml5Validity()

      if (this.requireValidation) {
        this.$refs.professional_numberField.checkHtml5Validity()
        return (
          this.$refs.nameField.isValid &&
          this.$refs.surnameField.isValid &&
          this.$refs.professional_numberField.isValid
        )
      } else
        return this.$refs.nameField.isValid && this.$refs.surnameField.isValid
    },

    validationNameRegister() {
      if (this.user_name === '') {
        this.nameType = 'is-danger'
        this.nameMsg = 'Completa este campo'
      } else if (this.user_name !== '') {
        this.nameType = 'is-primary'
        this.nameMsg = ''
        if (this.currentRole === 'doctor') {
          this.validateNumber();
        }
      }
    },

    validationSurnameRegister() {
      if (this.user_surname === '') {
        this.surnameType = 'is-danger'
        this.surnameMsg = 'Completa este campo'
      } else if (this.user_surname !== '') {
        this.surnameType = 'is-primary'
        this.surnameMsg = ''
        if (this.currentRole === 'doctor') {
          this.validateNumber();
        }
      }
    },

    validationProfNumberRegister() {
      if (this.professional_number === '') {
        this.colegiadoType = 'is-danger'
        this.colegiadoMsg = 'Completa este campo'
      } else if (this.professional_number !== '') {
        this.colegiadoType = 'is-primary'
        this.colegiadoMsg = ''

        //Usar cuando se use Api CGCOM para validar
         if (this.currentRole === 'doctor') {
          this.validateNumber();
         }
        
        //Usar cuando no se use Api CGCOM para validar
        //if (this.currentRole === 'doctor' && this.professional_number.length < 13) {
        // this.colegiadoType = 'is-danger'
        // this.colegiadoMsg = 'Introduce los 9 dígitos'
        //}     
      }
    },

    validationProfDocRegister() {
      if (this.doctor_professional_doc === null) {
        this.docType = 'is-danger'
        this.docMsg = 'Documento requerido'
      } else if (this.doctor_professional_doc !== null) {
        this.file_ext = this.doctor_professional_doc.name.split('.').pop()
      
        if (['jpg', 'jpeg', 'png', 'pdf'].includes(this.file_ext)) { 
         this.docType = ''
         this.docMsg = ''
        } else {
         this.docType = 'is-danger'
         this.docMsg = 'Extensión no permitida'
       }
      }
    },

    nextStep() {

      if (this.currentRole === 'doctor') {
        if (this.user_name === '' || this.user_surname === '' || this.professional_number === '' || this.professional_number.length < 13) {
          this.validationNameRegister();
          this.validationSurnameRegister();
          this.validationProfNumberRegister();
          return false;
        }
      }

      if (this.currentRole !== 'doctor' || this.getCountry.id !== 'ES') {
        if (this.user_name === '' || this.user_surname === '' || this.professional_number === '' || this.doctor_professional_doc === null || ['jpg', 'jpeg', 'png', 'pdf'].includes(this.file_ext) === false) {
          this.validationNameRegister();
          this.validationSurnameRegister();
          this.validationProfNumberRegister();
          this.validationProfDocRegister();
          return false;
        }
      }

      console.log('next step');
      if (this.isWaitingValidation === true) {
        this.nextStepWaitingValidation = true
        return
      } else {
        this.nextStepWaitingValidation = false
      }

      if (
        this.requireValidation &&
        this.isFormValid() == true &&
        this.verificado == false &&
        this.showNoverificado == false
      ) {
        this.showNoverificado = true
        this.showErrorModal = true
      }

      if (
        (this.isFormValid() == true && this.requireValidation == false) ||
        (this.isFormValid() == true &&
          this.verificado == false &&
          this.showNoverificado == true) ||
        (this.isFormValid() == true && this.verificado == true)
      ) {
        this.$store.commit('register/setStep2', {
          doctor_title: this.doctor_title,
          doctor_resident: this.doctor_resident,
          doctor_resident_year: this.doctor_resident_year,
          user_name: this.user_name,
          user_surname: this.user_surname,
          user_surname2: this.user_surname2,
          professional_number: this.generateProfessional_number(),
          doctor_professional_doc: this.doctor_professional_doc_base64
        })

        if (this.getFieldInfo('numcol') === undefined) {
          this.$matomo.trackEvent(this.generateMatomoEventCategory(), 'Step 42', 'Next')
        } else {
          if (this.verificado == true) {
            this.$matomo.trackEvent(this.generateMatomoEventCategory(), 'Step 41', 'Next')
          } else {
            this.$matomo.trackEvent(
              'user_register',
              'Step 41',
              'DoctorNumError'
            )
          }
        }

        this.$store.commit('register/nextStep')
      }
    },
    closeRegister() {
      this.$dialog.confirm({
        message: '¿Estás seguro de que quieres cancelar el registro?',
        onConfirm: () =>
          this.$router.push('/home').catch(error => {
            console.info(error.message)
          })
      })
    }
  }
}
</script>
<style lang="less" scoped>
//@import (reference) '../../assets/styles/main.less';
#register-card {
  background-color: #0ac6d3;
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.b-radio.radio.button.is-success span {
  color: white;
}

.apellido {
  margin-left: 15px;
}

#colegiado-number .onlyline {
  margin-right: 1em;
}

.professional_number {
  width: 10em;
}

input[type='number']::-webkit-outer-spin-button,
input[type='number']::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* For Firefox */
input[type='number'] {
  -moz-appearance: textfield;
}

/* Webkit browsers like Safari and Chrome */
input[type='number']::-webkit-inner-spin-button,
input[type='number']::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.file-label,
.file-icon {
  color: white;
}

.file {
  flex-direction: column;
}

.input-row input[type='number']::-webkit-inner-spin-button,
.input-row input[type='number']::-webkit-outer-spin-button {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  margin: 0;
}

.anios-container {
  margin-bottom: 1em;
}

.usuario-verificado,
.usuario-no-verificado {
  width: 100%;
  font-style: normal;
  font-weight: normal;
  line-height: normal;
  font-size: 28px;
  text-align: center;
}

div.usuario-no-verificado {
  color: #ee3300;
  font-size: 25px;
}
</style>
